export default {
  heading: {
    widgetName: "toplist",
    widgetID: "107",
    widgetWidth: "3",
    cardCount: "4",
    layoutName: "lob_widget",
    headline: "Read Reviews & Top Lists",
    subHeadline: "Learn more about Certified Super establishments",
    showMoreURL: "https://www.airasia.com/play/search?tag=certified%20super",
    gtmParameters: {
      event: "trackEventNoEcommerce",
      eventActionClick: "click",
      eventActionView: "view",
      eventCategory: `certifiedsuper | Browse Certified Super Hotels`,
      eventLabelCardClick: `certifiedsuper | {{cardtitle}} | {{cardwidth}} | {{cardposition}} | {{redirecturl}}`,
      eventLabelHeadlineClick: `certifiedsuper | headline | {{headline}}`,
      eventLabelView: `certifiedsuper`,
    },
  },

  data: [
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt39aa202c1d0039a6/62e0d5eb5c954177895ab6e0/hyderabadibriyani.jpg",
      title: "Where to Find Authentic Hyderabadi Biryani in Kuala Lumpur",
      cta: "Read More",
      url: "https://www.airasia.com/play/assets/bltdde37aa5b61e5fcf/where-to-find-authentic-hyderabadi-biryani-in-kuala-lumpur"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt4a270ecd2a005281/62ba6811ff0f000f7b264b88/jjinjjayoo.jpg",
      title: "Jinjjayoo’s Rice Bowls Offer a Hearty Introduction to Korean Food",
      cta: "Read More",
      url: "https://www.airasia.com/play/assets/blt2ca2a2725dfc0a70/jinjjayoos-rice-bowls-offer-a-hearty-introduction-to-korean-food"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt9c0a4b2266bf11b6/62a03d785711a40f708cca91/hoganbakery.jpg",
      title: "Why Hogan Bakery Will Spoil All the Other for You",
      cta: "Read More",
      url: "https://www.airasia.com/play/assets/blt61fb71e86e55e864/why-hogan-bakery-will-spoil-all-the-others-for-you"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt4cbacd389053dbd8/62a03d78e95fa50f854de53e/sneakyburgers.jpg",
      title: "Sneaky Burgers Will Leave You Squealing With Joy",
      cta: "Read More",
      url: "https://www.airasia.com/play/assets/blt40bb7d147f3bcb8b/sneaky-burgers-porky-gems-will-leave-you-squealing-with-joy"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt1f91b9dee341776b/6273a3038c90c334d0d4119b/joshi_josh.jpg",
      title: "Joshijosh & Soh.ya, the Place to Go for Comfort Food",
      cta: "Read More",
      url: "https://www.airasia.com/play/assets/blt75157270dd402c3d/joshijosh-soh-ya-the-place-to-go-for-comfort-food"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blta41fb92b0c655d61/6273a3039dfd5f30d076eeb5/wellness_retreats.jpg",
      title: "8 Wellness Retreats in Thailand for Rest and Rejuvenation",
      cta: "Read More",
      url: "https://www.airasia.com/play/assets/blt968bb915af6d002f/8-wellness-retreats-in-thailand-for-rest-and-rejuvenation"
    },
    {
      image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/blt42802c79c90ecadd/6273a3035d936230ca8eb75a/siem_reap.jpg",
      title: "What to See and Do in Siem Reap, the Gateway to Angkor",
      cta: "Read More",
      url: "https://www.airasia.com/play/assets/blt5d860c98a97e8016/what-to-see-and-do-in-siem-reap-the-gateway-to-angkor"
    }
    // {
    //   image: "https://images.contentstack.io/v3/assets/blt81780e535e9d8b2b/bltdde7e9a43ef4d80d/6273a30376b17f2f94787d39/scenic_parks.jpg",
    //   title: "10 Most Scenic Parks in Seoul to Catch Views",
    //   cta: "Read More",
    //   url: "https://www.airasia.com/play/assets/bltb8c01e4725323f0f/10-most-scenic-parks-in-seoul-to-catch-views"
    // }
  ],
}
